import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';

var identity = function identity(value) {
  return value;
};

var IconWrapper = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var className = props.className,
      icon = props.icon;

  if (icon == null || typeof icon === 'string') {
    return null;
  }

  if ( /*#__PURE__*/React.isValidElement(icon)) {
    return /*#__PURE__*/React.cloneElement(icon, _objectSpread(_objectSpread({}, icon.props), {}, {
      className: [icon.props.className, className].filter(identity).join(' '),
      ref: forwardedRef
    }));
  } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - TypeScript being dumb again.
  // https://github.com/microsoft/TypeScript/issues/13995


  return /*#__PURE__*/React.createElement(icon, {
    className: className,
    ref: forwardedRef
  }); // Casting is necessary due to TypeScript's inability to retain free type
  // parameters when doing higher order functional programming.
  // https://bit.ly/3meILJk
});
export default IconWrapper;